module.exports = __webpack_public_path__ + "img/Q8.e61357fa.png";